import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getDimensionList } from 'src/redux/Actions/VehicleTracking';
import { ReactComponent as Delete } from 'src/Images/icons/common/delete.svg';
import { ReactComponent as EmptyCheckIcon } from 'src/Images/icons/common/emptyCheckIcon.svg';
import { ReactComponent as EmptyCheckBoxIcon } from 'src/Images/icons/common/empty-check-box.svg';
import { ReactComponent as FilleCheckBox } from 'src/Images/icons/common/filledCheckBox.svg';
import { ReactComponent as StringIcon } from 'src/Images/icons/common/stringIcon.svg';
import { ReactComponent as ToggleIcon } from 'src/Images/icons/common/toggleIcon.svg';
import { ReactComponent as AddIcon } from 'src/Images/icons/common/addIcon.svg';
import { ReactComponent as Cube } from 'src/Images/icons/common/cube.svg';
import QualitycheckTargetModal from 'src/components/Settings/QualityCheck/QualitycheckTargetModal';
import { ReactComponent as LengthIcon } from 'src/Images/icons/common/LengthIcon.svg';

export default function AddDimensionComponent({ formData, setFormData }) {
  const dispatch = useDispatch();
  const [addTargetValueModal, setAddTargetValueModal] = useState(false);
  const [activeDimension, setActiveDimension] = useState(null);
  const [numericType, setNumericType] = useState('range');
  const [dimensionSearchTerm, setDimensionSearchTerm] = useState('');
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );

  const { dimensionList } = vehicleTrackingReducer;
  const [allDimensions, setAllDimensions] = useState([]);

  useEffect(() => {
    if (dimensionList.length && allDimensions.length === 0) {
      setAllDimensions(dimensionList);
    }
  }, [dimensionList, allDimensions]);

  useEffect(() => {
    dispatch(getDimensionList(tenantOrganisationId, ''));
  }, [dispatch, tenantOrganisationId]);

  useEffect(() => {
    const delay = setTimeout(() => {
      dispatch(getDimensionList(tenantOrganisationId, dimensionSearchTerm));
    }, 400);
    return () => clearTimeout(delay);
  }, [dispatch, tenantOrganisationId, dimensionSearchTerm]);

  const handleAddDimension = (dimensionObj) => {
    if (
      !formData.dimensions.some(
        (dimensionIdObj) => dimensionIdObj.dimension_id === dimensionObj.id,
      )
    ) {
      setFormData((prev) => ({
        ...prev,
        dimensions: [...prev.dimensions, { dimension_id: dimensionObj.id }],
      }));
    }
  };

  const handleRemoveDimension = (id) => {
    setFormData((prev) => ({
      ...prev,
      dimensions: prev.dimensions.filter(
        (dimensionObj) => dimensionObj.dimension_id !== id,
      ),
    }));
  };

  const addTargetModal = (dimension) => {
    setActiveDimension(dimension);
    setAddTargetValueModal(true);
  };

  const handleAddDimensionValue = (dimensionId, valueObj) => {
    setFormData((prev) => {
      const defaultDimension = {
        dimension_id: dimensionId,
        targetValue: null,
        targetMinValue: null,
        targetMaxValue: null,
        targetBoolean: null,
        targetOption: null,
      };

      const existingDimensions = prev.dimensions.find(
        (dimensionObj) => dimensionObj.dimension_id === dimensionId,
      );

      let updatedDimensions;
      if (existingDimensions) {
        updatedDimensions = prev.dimensions.map((dimensionObj) =>
          dimensionObj.dimension_id === dimensionId
            ? { ...defaultDimension, ...dimensionObj, ...valueObj }
            : dimensionObj,
        );
      } else {
        updatedDimensions = [
          ...prev.dimensions,
          { ...defaultDimension, ...valueObj },
        ];
      }

      return { ...prev, dimensions: updatedDimensions };
    });
  };

  const selectedDimensions = allDimensions.filter((dimensionObj) =>
    formData.dimensions.some(
      (formDatadimensionObj) =>
        formDatadimensionObj.dimension_id === dimensionObj.id,
    ),
  );

  const handleNumericTypeChange = (type) => {
    setNumericType(type);
    if (activeDimension) {
      handleAddDimensionValue(activeDimension.id, {
        targetValue: '',
        targetMinValue: '',
        targetMaxValue: '',
      });
    }
  };

  const getUpdatedOptions = (e, currentOptions, optionId) =>
    e.target.checked
      ? [...currentOptions, optionId]
      : currentOptions.filter((id) => id !== optionId);

  return (
    <div className="div-flex-column rg-10 horizontal-padding-10">
      <Row className="g-3 padding-top-10">
        <Col xxl={4} xl={4} lg={4}>
          <Row className="padding-bottom-10 padding-top-10 right-padding-10 ">
            <Col xxl={12} xl={12} lg={12}>
              <div className="input-wrapper">
                <input
                  className="form-input-section"
                  name="attribute"
                  placeholder="Search Dimension"
                  value={dimensionSearchTerm}
                  onChange={(e) => setDimensionSearchTerm(e.target.value)}
                />
                <span className="form-input-section-icon">
                  <Search className="icon-size-sm" color="#9F9F9F" />
                </span>
              </div>
            </Col>
          </Row>
          <div
            className={`quality-check-product-left-height border-right padding-top-10 div-flex-column rg-10 theme-scrollable-container-${themeColor}`}
          >
            {dimensionList.map((dimensionObj) => {
              const isSelected = formData.dimensions.some(
                (d) => d.dimension_id === dimensionObj.id,
              );
              return (
                <div
                  className="quality-check-list-data div-flex-row div-space-between border border-radius-4 right-margin-10"
                  key={dimensionObj.id}
                >
                  <span className="text-sm">{dimensionObj.name}</span>

                  <button
                    type="button"
                    aria-label={
                      isSelected ? 'Remove dimension' : 'Add dimension'
                    }
                    className="text-sm cursor-pointer bg-transparent border-0 p-0"
                    onClick={() => {
                      if (!isSelected) handleAddDimension(dimensionObj);
                    }}
                  >
                    {isSelected ? (
                      <EmptyCheckIcon className="icon-size-lg" />
                    ) : (
                      <AddIcon className="icon-size-lg" />
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        </Col>
        <Col xxl={8} xl={8} lg={8}>
          {selectedDimensions.length === 0 ? (
            <div className="div-flex-column rg-10">
              <span className="text-md text-semi-bold padding-bottom-13 border-bottom padding-top-10">
                Selected Dimensions
              </span>
              <div className="quality-check-empty-state-height div-flex-column-center">
                <Cube className="icon-size-large" />
                <span className="text-xxl text-semi-bold">List is empty</span>
                <span className="text-sm text-grey">
                  Your selected dimension list is currently empty.
                  <br />
                  Select the dimensions from the left
                  <br />
                  to add the attribute
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column rg-10">
              <span className="text-md text-semi-bold padding-bottom-13 border-bottom padding-top-10">
                Selected Dimensions
              </span>
              <div className="quality-check-create-order-item-table-wrapper">
                <table className="quality-check-create-order-item-table">
                  <thead>
                    <tr>
                      <th className="table-head-40">
                        <span className="text-sm text-grey text-semi-bold">
                          #
                        </span>
                      </th>
                      <th className="table-head-120">
                        <span className="text-sm text-grey text-semi-bold">
                          Dimension Name
                        </span>
                      </th>
                      <th className="table-head-300">
                        <span className="text-sm text-grey text-semi-bold">
                          Dimension Value
                        </span>
                      </th>
                      <th className="table-head-120">
                        <span className="text-sm text-grey text-semi-bold">
                          Action
                        </span>
                      </th>
                      <th className="table-head-40" aria-label="actions" />
                    </tr>
                  </thead>
                  <tbody>
                    {selectedDimensions.map((dim, index) => (
                      <tr key={dim.id}>
                        <td>
                          <span className="text-sm text-nowrap">
                            {index + 1}
                          </span>
                        </td>

                        <td>
                          <span className="text-sm text-nowrap">
                            {dim.name}
                          </span>
                        </td>

                        <td>
                          <span className="text-sm text-nowrap">
                            {(() => {
                              const dimensionData = formData.dimensions.find(
                                (dimensionObj) =>
                                  dimensionObj.dimension_id === dim.id,
                              );

                              if (!dimensionData) return '--';

                              switch (dim.data_type?.id) {
                                case 1:
                                case 2: {
                                  const min =
                                    dimensionData.targetMinValue ?? '';
                                  const max =
                                    dimensionData.targetMaxValue ?? '';
                                  const val = dimensionData.targetValue ?? '';
                                  if (!min && !max && val) {
                                    return (
                                      <div className="div-flex-column rg-20">
                                        <div className="div-flex-row cg-5">
                                          <div className="quality-check-input-group">
                                            <span className="quality-check-input-field div-align-center text-grey">
                                              {val}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                  if (min || max || val) {
                                    return (
                                      <div className="div-flex-column rg-20">
                                        <div className="div-flex-row cg-5">
                                          <div className="quality-check-input-group">
                                            <span className="quality-check-input-addon">
                                              &gt;
                                            </span>
                                            <span className="quality-check-input-field div-align-center text-grey">
                                              {min}
                                            </span>
                                          </div>
                                          <span className="text-md text-grey div-align-center">
                                            to
                                          </span>
                                          <div className="quality-check-input-group">
                                            <span className="quality-check-input-addon">
                                              &lt;
                                            </span>
                                            <span className="quality-check-input-field div-align-center text-grey">
                                              {max}
                                            </span>
                                          </div>
                                          <div className="quality-check-input-group">
                                            <span className="quality-check-input-field div-align-center text-grey">
                                              {val}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                  // If nothing is entered, show placeholders
                                  return (
                                    <div className="div-flex-row cg-5">
                                      <div className="div-flex-row div-align-center">
                                        <LengthIcon className="icon-size-xxl" />
                                      </div>
                                      <span className="text-sm text-grey">
                                        Click on set target button at the side
                                        to set target value for your dimension
                                      </span>
                                    </div>
                                  );
                                }
                                case 3: // String
                                  return dimensionData.targetValue ? (
                                    <span className="text-sm text-grey text-ellipsis quality-check-list-data div-flex-row border border-radius-4">
                                      {dimensionData.targetValue}
                                    </span>
                                  ) : (
                                    <div className="div-flex-row cg-5">
                                      <div className="div-flex-row div-align-center">
                                        <StringIcon className="icon-size-xxl" />
                                      </div>
                                      <span className="text-sm text-grey">
                                        Click on set target button at the side
                                        to create an attribute for your
                                        dimension
                                      </span>
                                    </div>
                                  );

                                case 4: // Choice / Option
                                  if (dimensionData.targetOption?.length > 0) {
                                    // Map IDs to names
                                    const selectedOptions = dim.available_values
                                      ?.filter((choiceObj) =>
                                        dimensionData.targetOption.includes(
                                          choiceObj.id,
                                        ),
                                      )
                                      .map((choiceObj) => choiceObj.name)
                                      .join(', ');

                                    return selectedOptions ? (
                                      <span className="text-sm text-grey quality-check-list-data div-flex-row border border-radius-4">
                                        {selectedOptions}
                                      </span>
                                    ) : (
                                      '--'
                                    );
                                  }
                                  return (
                                    <div className=" div-flex-row cg-5">
                                      <div className=" div-flex-row cg-5 div-align-center">
                                        <EmptyCheckBoxIcon className="icon-size-sm" />
                                        <FilleCheckBox className="icon-size-sm" />
                                      </div>
                                      <span className="text-sm text-grey">
                                        Click on set target button at the side
                                        to create an attribute for your
                                        dimension{' '}
                                      </span>
                                    </div>
                                  );

                                case 5: // Boolean
                                  return dimensionData.targetBoolean == null ? ( // checks for null OR undefined
                                    <div className="div-flex-row cg-5">
                                      <div className="div-flex-row div-align-center">
                                        <ToggleIcon className="icon-size-xxl" />
                                      </div>
                                      <span className="text-sm text-grey">
                                        Click on set target button at the side
                                        to create an attribute for your
                                        dimension
                                      </span>
                                    </div>
                                  ) : dimensionData.targetBoolean ? (
                                    <div className="quality-check-list-data div-flex-row div-align-center div-space-between border border-radius-4">
                                      <span className="text-sm text-grey">
                                        If the quality check condition is
                                      </span>
                                      <span className="text-sm text-green  bg-green quality-check-boolean-padding border-green border-radius-4">
                                        True
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="quality-check-list-data div-flex-row div-align-center div-space-between border border-radius-4">
                                      <span className="text-sm text-grey">
                                        If the quality check condition is
                                      </span>
                                      <span className="text-sm text-red  quality-check-bg-red quality-check-boolean-padding border-red border-radius-4">
                                        False
                                      </span>
                                    </div>
                                  );

                                default:
                                  return '--';
                              }
                            })()}
                          </span>
                        </td>
                        <td>
                          {(() => {
                            const dimensionData = formData.dimensions.find(
                              (dimensionObj) =>
                                dimensionObj.dimension_id === dim.id,
                            );

                            const isEdit = (() => {
                              if (!dimensionData) return false;

                              switch (dim.data_type?.id) {
                                case 1:
                                case 2:
                                  return (
                                    dimensionData.targetMinValue ||
                                    dimensionData.targetMaxValue ||
                                    dimensionData.targetValue
                                  );

                                case 3: // String
                                  return !!dimensionData.targetValue;

                                case 4: // Choice / Option
                                  return dimensionData.targetOption?.length > 0;

                                case 5: // Boolean
                                  return dimensionData.targetBoolean != null;

                                default:
                                  return false;
                              }
                            })();

                            return isEdit ? (
                              <button
                                type="button"
                                className={`common-btn-outlined border-${themeColor}`}
                                onClick={() => addTargetModal(dim)}
                              >
                                Edit Value
                              </button>
                            ) : (
                              <button
                                type="button"
                                className={`common-btn-filled theme-background-${themeColor}`}
                                onClick={() => addTargetModal(dim)}
                              >
                                Set Target
                              </button>
                            );
                          })()}
                        </td>
                        <td>
                          <Delete
                            className="icon-size-lg div-flex-column cursor-pointer div-align-center"
                            onClick={() => handleRemoveDimension(dim.id)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <QualitycheckTargetModal
        addTargetValueModal={addTargetValueModal}
        setAddTargetValueModal={setAddTargetValueModal}
        activeDimension={activeDimension}
        numericType={numericType}
        handleNumericTypeChange={handleNumericTypeChange}
        formData={formData}
        handleAddDimensionValue={handleAddDimensionValue}
        getUpdatedOptions={getUpdatedOptions}
        themeColor={themeColor}
      />
    </div>
  );
}
